import React from "react";
import { Box } from "@mui/material";
import { isEdge } from "react-device-detect";

const bg = {
  image: "url('/imgs/classic/rocketSky.png')",
  posX: {
    xs: "72%",
    sm: "66%",
    md: "72%",
    lg: isEdge ? "-340px" : "-210px",
    xl: "0px",
  },
  posY: {
    xs: "58%",
    sm: "56%",
    md: "52%",
    lg: "-170px",
    xl: "-170px",
  },
};

export const HomeSkyBackground = () => (
  <>
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: -3,
        backgroundImage: bg.image,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: {
          xs: `${bg.posX.xs} ${bg.posY.xs}`,
          sm: `${bg.posX.sm} ${bg.posY.sm}`,
          md: `${bg.posX.md} ${bg.posY.md}`,
          xl: `${bg.posX.xl} ${bg.posY.xl}`,
        },
      }}
    />

    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: -2,
        background: {
          xs: "linear-gradient(180deg, rgba(20,55,74,0.86) 0%, rgba(20,55,74,0.72) 38%, rgba(20,55,74,0.30) 100%)",
          md: "linear-gradient(90deg, rgba(20,55,74,0.86) 0%, rgba(20,55,74,0.65) 42%, rgba(20,55,74,0.18) 100%)",
        },
      }}
    />

    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        pointerEvents: "none",
        opacity: 0.9,
        background:
          "radial-gradient(520px 260px at 18% 10%, rgba(92,181,179,0.42) 0%, rgba(92,181,179,0) 60%), radial-gradient(520px 320px at 92% 18%, rgba(244,180,79,0.35) 0%, rgba(244,180,79,0) 58%), radial-gradient(700px 520px at 50% 92%, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 65%)",
      }}
    />
  </>
);
